import { combineReducers } from "redux";

import { incassaSubitoConstants } from "../actions/incassaSubito";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  }
};

function privacy(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function totalEligibleInvoices(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case incassaSubitoConstants.GET_ELIGIBLE_INVOICES_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      },
      user: null
    };
  case incassaSubitoConstants.GET_ELIGIBLE_INVOICES_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case incassaSubitoConstants.GET_ELIGIBLE_INVOICES_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

export const incassaSubito = combineReducers({
  privacy,
  totalEligibleInvoices
});

export default incassaSubito;
